import React from 'react';

const values = [
  {
    icon: '◈',
    title: 'NORSK KVALITET',
    desc: 'Vi er stolt norske. Hvert eneste aspekt av NordPass er bygget med norsk presisjon og grundighet — fra kartdata til kundeservice.',
    color: '#3B6FD4',
    bg: 'rgba(59,111,212,0.08)'
  },
  {
    icon: '◉',
    title: 'ÅPENHET',
    desc: 'Ingen skjulte avgifter, ingen overraskelser. Vi er transparente om priser, data og hvordan plattformen fungerer.',
    color: '#E8A838',
    bg: 'rgba(232,168,56,0.06)'
  },
  {
    icon: '◎',
    title: 'BÆREKRAFT',
    desc: 'Vi hjelper sjåfører med å velge grønnere ruter og støtter overgangen til elektriske kjøretøy med spesialiserte elbil-funksjoner.',
    color: '#4CAF50',
    bg: 'rgba(76,175,80,0.06)'
  },
  {
    icon: '◆',
    title: 'INNOVASJON',
    desc: 'Vi utfordrer status quo i norsk veiteknologi. Maskinlæring, sanntidsdata og prediktiv analyse er kjernen i det vi bygger.',
    color: '#E84040',
    bg: 'rgba(232,64,64,0.06)'
  },
  {
    icon: '◇',
    title: 'PERSONVERN',
    desc: 'Dine data tilhører deg. Vi følger GDPR strengt og selger aldri brukerdata til tredjeparter.',
    color: '#9C27B0',
    bg: 'rgba(156,39,176,0.06)'
  },
  {
    icon: '○',
    title: 'FELLESSKAP',
    desc: 'NordPass er bygget av og for norske sjåfører. Brukerinnspill former produktutviklingen vår direkte.',
    color: '#00BCD4',
    bg: 'rgba(0,188,212,0.06)'
  }
];

const ValuesSection = () => {
  return (
    <section style={{ background: '#080E1A', padding: '120px 0', position: 'relative', overflow: 'hidden' }}>
      {/* Rotated background text */}
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%) rotate(-12deg)',
        fontFamily: 'Syne, sans-serif',
        fontSize: 'clamp(6rem, 15vw, 14rem)',
        fontWeight: 800,
        color: 'rgba(59,111,212,0.03)',
        letterSpacing: '-0.05em',
        whiteSpace: 'nowrap',
        pointerEvents: 'none',
        userSelect: 'none'
      }}>VERDIER</div>
      <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 5%', position: 'relative', zIndex: 1 }}>
        {/* Header */}
        <div style={{ marginBottom: '80px', display: 'flex', alignItems: 'flex-end', gap: '60px' }}>
          <div>
            <div style={{
              fontFamily: 'JetBrains Mono, monospace',
              fontSize: '0.6875rem',
              color: '#3B6FD4',
              letterSpacing: '0.2em',
              textTransform: 'uppercase',
              marginBottom: '16px',
              display: 'flex',
              alignItems: 'center',
              gap: '12px'
            }}>
              <div style={{ width: '32px', height: '1px', background: '#3B6FD4' }} />
              VÅRE VERDIER
            </div>
            <h2 style={{
              fontFamily: 'Syne, sans-serif',
              fontSize: 'clamp(2rem, 4vw, 3.5rem)',
              fontWeight: 800,
              color: '#EEF0F2',
              letterSpacing: '-0.04em',
              lineHeight: 1,
              margin: 0
            }}>
              DET SOM DRIVER
              <br /><span style={{ color: '#3B6FD4' }}>OSS FREMOVER</span>
            </h2>
          </div>
        </div>

        {/* Values grid — asymmetric */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '2px' }}>
          {values?.map((v, i) => (
            <div
              key={i}
              style={{
                background: v?.bg,
                border: `1px solid ${v?.color}22`,
                padding: '48px 40px',
                position: 'relative',
                overflow: 'hidden',
                transform: i % 2 === 1 ? 'translateY(20px)' : 'none'
              }}
            >
              {/* Icon */}
              <div style={{
                fontFamily: 'monospace',
                fontSize: '2.5rem',
                color: v?.color,
                marginBottom: '24px',
                lineHeight: 1
              }}>{v?.icon}</div>

              {/* Number */}
              <div style={{
                position: 'absolute',
                top: '20px',
                right: '24px',
                fontFamily: 'Syne, sans-serif',
                fontSize: '4rem',
                fontWeight: 800,
                color: `${v?.color}15`,
                lineHeight: 1
              }}>0{i + 1}</div>

              <h3 style={{
                fontFamily: 'Syne, sans-serif',
                fontSize: '1rem',
                fontWeight: 800,
                color: '#EEF0F2',
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
                marginBottom: '16px'
              }}>{v?.title}</h3>
              <p style={{
                fontFamily: 'Inter, sans-serif',
                fontSize: '0.875rem',
                color: 'rgba(138,149,163,0.8)',
                lineHeight: 1.7
              }}>{v?.desc}</p>

              {/* Bottom accent */}
              <div style={{
                position: 'absolute',
                bottom: 0, left: 0, right: 0,
                height: '2px',
                background: v?.color,
                opacity: 0.4
              }} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;
